import { CSSProperties, ReactNode } from 'react';
import { ICellRendererParams } from 'ag-grid-community';

const containerStyle: CSSProperties = {
    height: 100,
    overflowX: 'hidden',
    overflowY: 'scroll',
    padding: '10px 0',
    display: 'grid',
};

const paragraphStyle: CSSProperties = {
    lineHeight: 1.2,
    wordBreak: 'break-word',
    margin: 0,
    marginBottom: '3px',
};

interface GridCellLargeTextScrollViewProps extends ICellRendererParams {}

//note: this is specifically for large text fields that need to scroll within the cell
// - use GridCellLongTextView for long text that doesn't need to scroll
// - this one has a hardcoded height of 100px, for use when the
// parent's row height is not set and percentage won't work;
// could be changed to a parameter if needed
export const GridCellLargeTextScrollView = ({ value }: GridCellLargeTextScrollViewProps): ReactNode => {
    return (
        <div style={containerStyle} className="scrolly">
            {value
                ?.toString()
                ?.split('\n')
                ?.map((paragraph, i) => (
                    <p key={i} style={paragraphStyle} title={paragraph}>
                        {paragraph}
                    </p>
                ))}
        </div>
    );
};
